import axios from 'axios';
import { API } from '../config';

export const apiClient = axios.create({
  baseURL: API,
});

apiClient.interceptors.request.use((config) => {
  // Check multiple localStorage locations for the session token
  // 1. Legacy key: 'sessionToken' (stored by old App.js flow)
  let token = localStorage.getItem('sessionToken');

  // 2. Current key: session_token inside 'puresouls_staff_user' object
  if (!token) {
    try {
      const savedUser = localStorage.getItem('puresouls_staff_user');
      if (savedUser) {
        const userData = JSON.parse(savedUser);
        token = userData.session_token || userData.sessionToken || null;
      }
    } catch (e) {
      // ignore parse errors
    }
  }

  if (token) {
    config.headers['X-Session-ID'] = token;
  }
  return config;
});

export const showToast = (message, type = 'success') => {
  const toast = document.createElement('div');
  toast.className = `fixed top-4 right-4 px-6 py-3 rounded-lg shadow-lg z-50 ${
    type === 'success' ? 'bg-green-500 text-white' : 'bg-red-500 text-white'
  }`;
  toast.textContent = message;
  document.body.appendChild(toast);
  setTimeout(() => {
    if (document.body.contains(toast)) document.body.removeChild(toast);
  }, 3000);
};
